module.exports = __webpack_public_path__ + "static/media/bg-take-prize-web-x2.08e48662.png";